export default __webpack_public_path__ + "static/media/poppins-bold.b8b1d11a.svg";